// ============================================================
// NCR → contractor assignment client (Brief v2 · Task 3 "contractor: view
// their own NCRs"). A QC manager assigns a punch item to a project contractor;
// the contractor's Punch List filters to items assigned to them.
//
// Punch items are keyed by `<record_key>#<item_idx>` — the stable, unique punch
// identity (one NCR reference can span several items). See migration 0023.
// ============================================================
import { supabase } from "./supabase";
import { getProjectId } from "./persistence";

export interface NcrAssignment {
  punch_key: string;
  contractor_id: string;
  contractor_name: string | null;
}

/** The stable punch-item key used for assignments. */
export function punchKey(p: { key: string; idx: number | string }): string {
  return `${p.key}#${p.idx}`;
}

/** punch_key → assignment, for the active project. */
export async function listNcrAssignments(): Promise<NcrAssignment[]> {
  if (!supabase) return [];
  try {
    const { data, error } = await supabase.rpc("list_ncr_assignments", { p_project: getProjectId() });
    if (error) return [];
    return (data || []) as NcrAssignment[];
  } catch {
    return [];
  }
}

/** Assign a punch item to a contractor (QC-manager only). */
export async function assignNcr(key: string, contractorId: string): Promise<void> {
  if (!supabase) throw new Error("Supabase not configured");
  const { error } = await supabase.rpc("assign_ncr", {
    p_project: getProjectId(),
    p_punch_key: key,
    p_contractor: contractorId,
  });
  if (error) throw error;
}

/** Clear an assignment (QC-manager only). */
export async function unassignNcr(key: string): Promise<void> {
  if (!supabase) throw new Error("Supabase not configured");
  const { error } = await supabase.rpc("unassign_ncr", { p_project: getProjectId(), p_punch_key: key });
  if (error) throw error;
}
